export interface NotifyEvent<T = unknown> {
    event: string;
    data: T;
}

export interface DownloadProcess {
    total: number;
    transfer: number;
    progress: number;
}

interface DownloadStatus {
    event: string;
    data: {
        filePath: string;
        total: number;
        progress: number;
    }
}

interface UploadProcesss {
    progress: number;
}

interface UploadStatus {
    event: string;
    data: {
        downloadUrl: string;
        fileKey: string;
        fileSize: number;
    }
}

interface ISelectePath {
    canceled: boolean;
    filePaths: string[];
    bookmarks?: string[];
}

const DataFlowApis = {
    async supportDataFlow(): Promise<boolean> {
        try {
            await window.LinkService?.request('/api/main/v1/dataFlow/isSupport', {});
            return true;
        } catch (error) {
            console.log('supportDataFlow error');
            return false;
        }
    },
    async checkHealth(ip: string, port: number): Promise<boolean> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/dataFlow/checkHealth', { ip, port });
            return res.data as boolean;
        } catch (error) {
            return false;
        }
    },
    async checkHealth2(url: string, timeout: number = 1000): Promise<boolean> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/dataFlow/checkHealth2', { url, timeout });
            return res.data as boolean;
        } catch (error) {
            return false;
        }
    },

    async selectSavePath(): Promise<ISelectePath | undefined> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/dataFlow/selectPath', {});
            return res.data;
        } catch (error) {
            return undefined;
        }
    },

    async downloadMeeting(ip: string, port: number, filePath: string, fileName: string): Promise<boolean> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/dataFlow/downloadMeeting', { ip, port, filePath, fileName });
            return res.data as boolean;
        } catch (error) {
            console.log('downloadMeeting err = ', error);
            return false;
        }
    },

    async uzipMeetingFile(filePath: string, outputPath?: string): Promise<Array<string>> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/dataFlow/uzipFile', { filePath, outputPath });
            return res.data;
        } catch (error) {
            console.log('uzipMeetingFile err = ', error);
            return [];
        }
    },

    async parseMeetingJson(jsonFilePath: string): Promise<unknown> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/dataFlow/parseMeetingJson', { jsonFilePath });
            return res.data;
        } catch (error) {
            console.log('parseMeetingJson err = ', error);
            return "";
        }
    },

    async deleteFile(filePath: string): Promise<unknown> {
        try {
            const res = await window.LinkService?.request('/api/main/v1/dataFlow/deleteFile', { filePath });
            return res.data;
        } catch (error) {
            console.log('deleteFile err = ', error);
            return false;
        }
    },

    downloadProcess(cb: (data: NotifyEvent<DownloadProcess>) => void) {
        return window.LinkService?.subscribe<NotifyEvent<DownloadProcess>>('/sub/main/v1/dataFlow/downloadMeetingProgress', cb);
    },

    downloadStatus(cb: (data: NotifyEvent<DownloadStatus>) => void) {
        return window.LinkService?.subscribe<NotifyEvent<DownloadStatus>>('/sub/main/v1/dataFlow/downloadStatus', cb);
    },

    async uploadAudioFile(filePath: string) {
        try {
            const res = await window.LinkService?.request('/api/main/v1/dataFlow/uploadAudio', {
                filePath,
                uploadoApi: `${import.meta.env.VITE_BACKEND_URL}/api/open/file-upload/upload/policy`
            });
            return res.data as boolean;
        } catch (error) {
            return false;
        }
    },

    uploadAudioProcess(cb: (data: NotifyEvent<UploadProcesss>) => void) {
        return window.LinkService?.subscribe<NotifyEvent<UploadProcesss>>('/sub/main/v1/dataFlow/uploadAudioProgress', cb);
    },

    uploadAudioStatus(cb: (data: NotifyEvent<UploadStatus>) => void) {
        return window.LinkService?.subscribe<NotifyEvent<UploadStatus>>('/sub/main/v1/dataFlow/uploadAudioStatus', cb);
    },
}

export default DataFlowApis;